<!-- SetupComponentsのテンプレートを書いておくのでこれ使って新規コンポーネント作成してくれると嬉しいです(改善等あれば随時変更してください) -->
<script lang="ts" setup>
import { TableContentFontSize } from '@/corePagesModule/BaseTableContent/interface/tableContentItems';
import { computed, ref } from 'vue';

// props
const props = withDefaults(
  defineProps<{
    toolTipValue?: string;
    textAlign?: string;
    fontSize?: TableContentFontSize;
    isBorder?: boolean;
  }>(),
  {
    toolTipValue: '',
    textAlign: 'left',
    fontSize: 'fontSizeSS',
    isBorder: true,
  }
);

//textAlign
const textAlign = ref(props.textAlign);

//fontSizeの切り替え
const fontSizeClass = computed(() => {
  return props.fontSize;
});

//fontSizeの切り替え
const borderBottomClass = computed(() => {
  return props.isBorder ? 'border-bottom' : undefined;
});

// emits
const emits = defineEmits<{
  (e: 'onClick'): void;
}>();

// 関数
/**
 * 文字列の長さによって、tooltip表示の有無を決める関数
 * @returns tooltip表示の有無
 */
const isDisplayTooltip = (): boolean => {
  if (!props.toolTipValue) return false;
  // 文字数の長さが26文字以上ならtrueを返す様にする
  // 文字数の全角半角カウントの処理は文字数の長さによって実行時間が長くなるため、回避策として追加
  if (props.toolTipValue.length === 26) return true;

  let count = 0; // 文字数カウント
  // 文字列を1文字ずつ全角半角判定を行う
  for (let i = 0, len = props.toolTipValue.length; i < len; i++) {
    // 改行コード判定
    if (props.toolTipValue[i].match(/^[^\x01-\x7E\uFF61-\uFF9F]+$/)) {
      // 全角判定
      count += 1;
    } else {
      // 半角判定
      count += 0.5;
    }
  }
  // 文字数カウントの切り上げ
  count = Math.ceil(count);

  // 文字数カウントが13以上ならtrueを返す
  if (count > 13) {
    return true;
  }
  return false;
};
</script>

<template>
  <td v-if="isDisplayTooltip()" v-tooltip.bottom="props.toolTipValue" :class="[fontSizeClass, borderBottomClass]" class="body-cell">
    <slot />
  </td>
  <td v-else :class="[fontSizeClass, borderBottomClass]" class="body-cell">
    <slot />
  </td>
</template>

<style lang="scss" scoped>
.body-cell {
  position: sticky;
  text-align: v-bind(textAlign);
  padding: 6px 8px;
  min-width: 32px;
  min-height: 24px;
  background-color: $semanticWhite;
  font-family: Noto Sans JP;
  color: $textSecondary;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* フォントサイズ切り替え用のクラス */
.fontSizeSS {
  font-size: $fontSizeSS;
}

.fontSizeS {
  font-size: $fontSizeS;
}

.fontSizeM {
  font-size: $fontSizeM;
}

.fontSizeL {
  font-size: $fontSizeL;
}

.border-bottom {
  border-bottom: 1px solid $borderDefault;
}
</style>
